// @ts-nocheck
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

import {
  FBoxContainer,
  FHSelect,
  FHSkeletonLoader,
  FProgressBar,
} from '../../../../../components/base';
import { BackgroundTypes } from '../../../../../constants';
import { FORTA_WHITE } from '../../../../../utils/colors';
import type { SelectValueType } from '../../../../../utils/types';
import { useProviderDetailsState } from '../../hooks';
import {
  RELATIONSHIP_MANAGER_SELECT_CONTAINER_SX,
  RELATIONSHIP_MANAGER_TITLE_SX,
} from '../../styles';
import { getRelationshipManagerDisplayValue, getRelationshipManagerOptions } from '../../utils';
import { ProviderQuestionnaire } from '../providerQuestionnaire';
import { useProviderRelationshipManager } from './hooks';

function ProviderQuestionnaireManagement() {
  const { provider } = useProviderDetailsState();
  const {
    isGuardianProvider,
    loading,
    saving,
    relationshipManagerCandidates,
    selectedRelationshipManagerId,
    handleUpdateRelationshipManager,
    handleClearRelationshipManager,
  } = useProviderRelationshipManager();

  if (!isGuardianProvider) {
    return null;
  }

  const renderRelationshipManagerValue = (selected: SelectValueType) =>
    getRelationshipManagerDisplayValue(selected, relationshipManagerCandidates);

  let relationshipManagerSection = null;
  if (loading) {
    relationshipManagerSection = (
      <Box>
        <FHSkeletonLoader height={30} width={280} sx={{ mb: 2 }} />
        <FHSkeletonLoader height={60} width="100%" />
      </Box>
    );
  } else {
    relationshipManagerSection = (
      <Box sx={{ borderRadius: '20px', mt: 3 }}>
        <Typography sx={RELATIONSHIP_MANAGER_TITLE_SX}>
          Assigned relationship manager
        </Typography>
        <Grid
          container
          p={2}
          spacing={1}
          direction="row"
          alignItems="center"
          sx={{ backgroundColor: FORTA_WHITE }}
        >
          <Grid item xs={12} md={8.5}>
            <Typography textAlign="left">Relationship manager</Typography>
          </Grid>
          <Grid item xs={12} md={3.5} sx={RELATIONSHIP_MANAGER_SELECT_CONTAINER_SX}>
            <FHSelect
              data-testid="relationshipManager"
              inputHeight={60}
              backgroundType={BackgroundTypes.White}
              fullWidth
              sx={{ flex: 1 }}
              displayEmpty
              selectFirstOption={false}
              disabled={saving}
              options={getRelationshipManagerOptions(relationshipManagerCandidates)}
              optionDataTestIdPrefix="relationship_manager"
              value={selectedRelationshipManagerId}
              renderValue={renderRelationshipManagerValue}
              onUpdate={handleUpdateRelationshipManager}
              helperTextAlign="left"
            />
            <IconButton
              aria-label="Clear relationship manager"
              disabled={!selectedRelationshipManagerId || saving}
              onClick={handleClearRelationshipManager}
            >
              <Close />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
    );
  }

  return (
    <FBoxContainer dataTestId="providerQuestionnaireManagement" sx={{ mt: 3 }}>
      {saving && <FProgressBar />}
      <Typography textAlign="left" variant="h4">
        Guardian Provider Questionnaire Management
      </Typography>
      {relationshipManagerSection}
      {provider?.id && <ProviderQuestionnaire providerId={provider.id} />}
    </FBoxContainer>
  );
}

export { ProviderQuestionnaireManagement };
